module.exports = __webpack_public_path__ + "static/media/group-inactive.bec02635.svg";